import { defineStore } from 'pinia'
import { useAppStore } from "@/store/modules/app";
import { useProjectsStore } from "@/store/modules/projects";

export const useTasksStore = defineStore('tasks', {
    state: () => ({
        tasks: [],
        queryParams: {
            filter: {},
            order: {}
        },
        pagination: {
            pages: 0,
            page: 1
        },
        q: ''
    }),
    getters: {
        arTasks() {
            return this.tasks;
        }
    },
    actions: {
        /**
         * Загрузка задач
         *
         * @param context
         * @returns {Promise<void>}
         */
        loadTasks(context) {
            const $this = this;
            const projectStore = useProjectsStore()
            const appStore = useAppStore()
            const params = this.queryParams
            const sort = appStore.getSort()
            const filter = appStore.getFilter()

            params.order = {}
            params.order[sort.by] = sort.order
            params.page = this.pagination.page
            params.filter = {};
            params.q = '';

            if (projectStore.selectedProject.ID) {
                params.filter = {
                    PROJECT_ID: projectStore.selectedProject.ID
                };
            }

            if (filter.field !== '') {
                params.filter[filter.field] = filter.value;
            }

            if (this.q !== '') {
                params['q'] = this.q
            }

            return context.postToServer('/tasks/getList', params, function (resp) {
                if (resp.data.result !== undefined) {
                    $this.tasks = [...$this.tasks, ...resp.data.result.items];
                    $this.pagination.pages = resp.data.result.pages;
                }

                return resp;
            });
        },
        /**
         * Добавление задачи
         *
         * @param fields
         * @param context
         */
        add(fields, context) {
            context.postToServer('/tasks/add', fields, function (resp) {
                if (!resp.data.error) {
                    context.$toast.add({severity: 'success', summary: 'Успешно', detail: 'Создана новая задача #' + resp.data.result, life: 3000});
                    context.$router.push('/tasks/' + resp.data.result);
                } else {
                    context.$toast.add({ severity: 'error', summary: 'Ошибка', detail: resp.data.error, life: 3000 });
                }
            },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        /**
         * Обновление задачи
         *
         * @param id
         * @param fields
         * @param context
         */
        update(id, fields, context) {
            context.postToServer('/tasks/update/' + id, fields, function (resp) {
                if (!resp.data.error) {
                    context.$toast.add({severity: 'success', summary: 'Успешно', detail: 'Обновлена задача #' + id, life: 3000});
                    context.$router.push('/tasks/' + id);
                } else {
                    context.$toast.add({ severity: 'error', summary: 'Ошибка', detail: resp.data.error, life: 3000 });
                }
            },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        /**
         * Удаление задачи по индексу
         *
         * @param index
         * @param context
         */
        deleteTaskByIndex(index, context) {
            if (index >= 0) {
                const $this = this;

                context.postToServer('/tasks/delete/' + this.tasks[index].ID, {}, function (resp) {
                    if (!resp.data.error) {
                        $this.tasks.splice(index, 1);
                        context.$toast.add({severity: 'success', summary: 'Успешно', detail: 'Задача успешно удалена', life: 3000});
                    } else {
                        context.$toast.add({ severity: 'error', summary: 'Ошибка', detail: resp.data.error, life: 3000 });
                    }
                });
            }
        },
        /**
         * Обновление статуса задачи по индексу
         *
         * @param index
         * @param status
         * @param context
         */
        updateStatus(index, status, context) {
            if (index >= 0) {
                const $this = this;

                context.postToServer('/tasks/updateStatus/' + this.tasks[index].ID + '/' + status, {}, function (resp) {
                    if (!resp.data.error) {
                        $this.tasks[index].STATUS_ID = resp.data.result.ID;
                        $this.tasks[index].STATUS__ID = resp.data.result.ID;
                        $this.tasks[index].STATUS__TITLE = resp.data.result.TITLE;
                        $this.tasks[index].STATUS__CODE = resp.data.result.CODE;
                        $this.tasks[index].STATUS__SORT = resp.data.result.SORT;
                        $this.tasks[index].STATUS__PROJECT_ID = resp.data.result.PROJECT_ID;

                        context.$toast.add({severity: 'success', summary: 'Успешно', detail: 'Статус задачи успешно обновлен', life: 3000});
                    } else {
                        context.$toast.add({ severity: 'error', summary: 'Ошибка', detail: resp.data.error, life: 3000 });
                    }
                });
            }
        },
        resetTasks() {
            this.tasks = [];
            this.pagination = {
                page: 1,
                pages: 0
            };
        }
    }
})